import api from 'src/utils/api';
import { E_API_SERVICEID } from 'src/utils/enum';


/**
 * @name 로그수집
 * @param screen_id 화면 아이디
 * @param action_id 유저 액션 아이디
 * @param action_detail 판매코드 or 배너 ID or SEQ_NO 
 * @param seq 인덱스 번호
 */
export const apiPostLog = async params => {
  const response = await api.post(
    '/fo/logging',
    {...params},
    {
      baseURL: process.env.REACT_APP_LOG_API,
      headers: { 'x-ssp-gateway-service-id': E_API_SERVICEID.LOG },
    },
  );

  const data = response.data;

  return data;
};